//this file mange ui filters logic and take care to call dataAction to trigger data update (dataAction) when necessary
import _config from "@/assets/config/sourcesConfig.json";

const state = {
  config: null,
  mainSource: null,
  source: null,
  dataType: null,
  geoArea: null,
  selectedCountryId: null,
  isMenuOpen: false,
  isModalOpen: false,
  modalContent: null,
  previousLink: null,
  isDrillDownOpen: null,
  activeGraphic: null,
  scatterIndex: null,
  hoveredStacked: null,
  legendRadius: null,
};

const mutations = {
  setMainSource(state, value) {
    state.mainSource = value;
  },
  setSource(state, value) {
    state.source = value;
  },
  setDataType(state, value) {
    state.dataType = value;
  },
  setConfig(state, value) {
    state.config = value;
  },
  setGeoArea(state, value) {
    state.geoArea = value;
  },
  setSelectedCountryId(state, value) {
    state.selectedCountryId = value;
  },
  toggleMenu(state, value) {
    state.isMenuOpen = value;
  },
  toggleModal(state, value) {
    state.isModalOpen = value;
  },
  setModalContent(state, value) {
    state.modalContent = value;
  },
  setPreviousLink(state, value) {
    state.previousLink = value;
  },
  toggleDrillDown(state, value) {
    if (value)
      window.digitalData.push({
        event: "click-cta",
        pageEvent: {
          eventInfo: {
            eventDetail: "opened drill down",
            contentTitle: "Oil-Production quality",
            contentWidget: "wer",
            contentURL: window.location.href,
            ctaLabel: "Oil-Production quality",
          },
        },
      });
    state.isDrillDownOpen = value;
  },
  setActiveGraphic(state, value) {
    state.activeGraphic = value;
  },
  setScatterIndex(state, value) {
    state.scatterIndex = value;
  },
  setHoveredStacked(state, value) {
    state.hoveredStacked = value;
  },
  setLegendRadius(state, value) {
    state.legendRadius = value;
  },
};

const getters = {
  mainSource: (state) => state.mainSource,
  source: (state) => state.source,
  dataType: (state) => state.dataType,

  mainSourcesRegistry: (state) => state.config.mainSources,
  currentSourceConfig: (state) => {
    return state.config.mainSources.find((x) => x.key === state.mainSource);
  },
  geoAreas: (state) => state.config.geoAreas,
  geoArea: (state) => state.geoArea,

  dataSource: (state, getters) => {
    if (getters.currentSourceConfig) {
      return getters.currentSourceConfig.dataSource;
    }
  },
  uom: (state, getters) => {
    if (getters.currentSourceConfig) {
      return getters.currentSourceConfig.uoms;
    }
  },
  metadata: (state, getters) => {
    if (getters.currentSourceConfig) {
      return getters.currentSourceConfig.metadata;
    }
  },
  currentSelectionLabel: (state, getters) => {
    const dataType = getters.dataType;
    return dataType
      ? `${getters.mainSource} ${getters.dataType}`
      : `${getters.mainSource}`;
  },
  selectedCountryId: (state) => state.selectedCountryId,
  mapStyle: (state, getters) => {
    if (getters.currentSourceConfig) {
      return getters.currentSourceConfig.mapStyle;
    }
  },
  sourceColor:
    (state, getters) =>
    (index = null) => {
      if (index != null) {
        if (index === -1) {
          return "main";
        } else {
          return getters.mainSourcesRegistry[index].colorName;
        }
      } else if (getters.currentSourceConfig) {
        return getters.currentSourceConfig.colorName;
      }
    },
  isMenuOpen: (state) => state.isMenuOpen,
  isModalOpen: (state) => state.isModalOpen,
  modalContent: (state) => state.modalContent,
  isDrillDownOpen: (state) => state.isDrillDownOpen,
  activeGraphic: (state) => state.activeGraphic,
  scatterIndex: (state) => state.scatterIndex,
  hoveredStacked: (state) => state.hoveredStacked,
  legendRadius: (state) => state.legendRadius,
  previousLink: state => state.previousLink
};

// const dataAction = { root: true };
const actions = {
  loadConfig({ commit }) {
    commit("setConfig", _config);
  },
  setMainSource({ commit }, value) {
    commit("setMainSource", value);
  },
  setSource({ commit }, value) {
    commit("setSource", value);
  },
  setDataType({ commit }, value) {
    commit("setDataType", value);
  },
  setGeoArea({ commit }, value) {
    commit("setGeoArea", value);
  },
  setSelectedCountryId({ commit }, value) {
    commit("setSelectedCountryId", value);
  },
  toggleMenu({ commit }, value) {
    commit("toggleMenu", value);
  },
  toggleModal({ commit }, value) {
    commit("toggleModal", value);
  },
  setModalContent({ commit }, value) {
    commit("setModalContent", value);
  },
  setPreviousLink({ commit }, value) {
    commit("setPreviousLink", value);
  },
  toggleDrillDown({ commit }, value) {
    commit("toggleDrillDown", value);
  },
  setActiveGraphic({ commit }, value) {
    commit("setActiveGraphic", value);
  },
  setScatterIndex({ commit }, value) {
    commit("setScatterIndex", value);
  },
  setHoveredStacked({ commit }, value) {
    commit("setHoveredStacked", value);
  },
  setLegendRadius({ commit }, value) {
    console.log(typeof value);
    commit("setLegendRdius", value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
